import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { CreditCardValidator } from 'angular-cc-library';
import { SubscribtionService } from '../Services/subscribtion.service';
import { Subscribe, SubscribtionData, Status } from '../api/WickedApiClient';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { CancelSubscriptionComponent } from '../Dialogs/cancelSubscription/cancelSubscription.component';
import { MainService } from '../Services/service.service';

@Component({
    selector: 'app-subscription-information',
    templateUrl: './subscriptionInformation.component.html',
    styleUrls: ['./subscriptionInformation.component.css']
})
export class SubscriptionInformationComponent implements OnInit {
    
    public enableSubscription:boolean = false;

    public subscribtions: SubscribtionData[] = [];
    public name: string;;
    public creditCard: string;
    public price: string;
    public type: string;
    public zip: string;
    public nextBillingDate: string;
    public loaded: boolean = false
    constructor(private services: MainService, private subscribtionService: SubscribtionService, private router: Router, private dialog: MatDialog) {
        
        this.enableSubscription = services.enableSubscription;
        if(!this.enableSubscription){
            this.router.navigate(['']);
        }
    }

    cancelSubscriptionDialog(subscribtion: SubscribtionData) {
        let dialogRef = this.dialog.open(CancelSubscriptionComponent, {
            data: subscribtion
        });

        dialogRef.afterClosed().subscribe(result => {
            if ((result as boolean)) {
                this.loadData();
               
            }
        });
    }

    private _activeSubscription: boolean = false;
    public get activeSubscription(): boolean {
        return this._activeSubscription;
    }
    public set activeSubscription(value: boolean) {
        this._activeSubscription = value;
    }

    public get getFirstInactive()
    {
        let filtered = this.subscribtions.filter(v=>{
            return v.status!=Status.Active
        })

        if(filtered)
        {   
            return filtered[0].subscribtionId
        }

        return "0";
    }


    isActive(active: Status) {
        return active == Status.Active;
    }

    loadData() {
        this._activeSubscription = false;
        this.loaded = false;
        this.subscribtionService.hasUserSubscribtion().then((hasSubscription) => {

            // if (!hasSubscription) {
              
            //     this.loaded = true
            // }
            // else {
                this.subscribtionService.get().then(data => {
                    this.subscribtions = data;
                  if (this.subscribtions.length > 0 || this.services.userService.isAdmin())
                    {
                        let active = this.subscribtions.find(v=>{
                            return v.status == Status.Active
                        })

                    if (active != undefined || this.services.userService.isAdmin())
                        {
                            this.userHasActiveSubscription = true;
                        }
                        else
                        {
                            this.userHasActiveSubscription = false;
                        }

                        this.activeSubscription = true;

                    }
                    else
                    {
                        this.activeSubscription = false;
  
                    }
                    this.loaded = true;
                });
        });
    }

    public isSubscriptionInfo:boolean = false
    public userHasActiveSubscription:boolean = false;

    public showForm()
    {
        this.isSubscriptionInfo = true;
        this.activeSubscription = false;
    }

    public subscribeFinished()
    {
        this.activeSubscription = true;
        this.loadData();
    }

    ngOnInit() {
        this.loadData();
    }


}
